/**
 * Stable CSS class names for E2E — Paylens Payment page.
 */
export const PP = {
    page: 'paylens-payment-page',
    frameCard: 'paylens-payment-page__frame-card',
    iframe: 'paylens-payment-page__iframe',
} as const;
